export const timeFiller = () => {
	return Array.from(
		{
			length: 24,
		},
		(_, i) => i
	);
};

export const TIME_CONSTANTS = {
	WORKING_HOURS_START: 8,
	WORKING_HOURS_END: 18,
};

export const generateEmptyWeeklyHourData =
	() => {
		return {
			mon: [],
			tue: [],
			wed: [],
			thu: [],
			fri: [],
			sat: [],
			sun: [],
		};
	};

export const generateFullWeeklyHourData = (): WeeklyHourData => {
  const fullDay = Array.from({ length: 24 }, (_, i) => i);

  return {
    mon: [...fullDay],
    tue: [...fullDay],
    wed: [...fullDay],
    thu: [...fullDay],
    fri: [...fullDay],
    sat: [...fullDay],
    sun: [...fullDay],
  };
};	

export const formatHour =
	(
		num: number
	) => {
		if (
			num <
			10
		) {
			return `0${num}:00`
		} else {
			return `${num}:00`
		}
	}

export const formatHourForDisplay =
	(
		startHour: number,
		endHour: number
	) => {
		return `${formatHour(startHour)} - ${endHour}:59`
	}

export const isOutOfDefaultRange =
	(
		selection: WeeklyHourData
	) => {
		const sortedFlatHours =
			[
				...new Set(
					Object.keys(
						selection
					)
						.map(
							(
								i
							) => {
								return selection![
									i as Day
								]
							}
						)
						.flatMap(
							(
								i
							) => [
									...i,
								]
						)
						.sort(
							(
								a,
								b
							) =>
								a -
								b
						)
				),
			]
		const shouldForceShow =
		{
			showEarlierHrs: false,
			showLaterHrs: false,
		}
		if (
			sortedFlatHours.filter(
				(
					i
				) =>
					i <
					TIME_CONSTANTS.WORKING_HOURS_START
			)
				.length
		) {
			shouldForceShow.showEarlierHrs = true
		}
		if (
			sortedFlatHours.filter(
				(
					i
				) =>
					i >
					TIME_CONSTANTS.WORKING_HOURS_END
			)
				.length
		) {
			shouldForceShow.showLaterHrs = true
		}
		return shouldForceShow
	}

export type Day =

	| "mon"
	| "tue"
	| "wed"
	| "thu"
	| "fri"
	| "sat"
	| "sun"
export type WeeklyHourData =
	{
		[key in Day]: number[]
	}
export type Preset =

	| "workingHours"
	| "nonWorkingHours"
	| "weekends"
	| "weekdays"


export const checkIfAllHoursAreSelected =
	(
		selection: WeeklyHourData
	) => {
		return Object.keys(
			selection
		)
			.map(
				(
					i
				) => {
					return selection![
						i as Day
					]
				}
			)
			.every(
				(
					i
				) => {
					return i.length === 24
				}
			)
	}